<form [formGroup]="form" class="form">

  @if (showStateCommercialTimberRights || (containsKoalaHabitatArea || containsKoalaPriorityArea || containsLocallyRefinedKoalaHabitatArea)) {
    <div>
      <h2>Acknowledgements</h2>
      <ol class="questions">
        @if (showStateCommercialTimberRights) {
          <div>
            <div class="state-commercial-timber-rights">
              <li>
                <legend>
                  <span class="label" [innerHtml]="stateCommercialTimberRightsHtmlMessage">
                  </span>
                  <abbr title="(required)" class="required">*</abbr>
                </legend>
                <ul class="choices">
                  <li class="required">
                    <input type="checkbox" id="stateCommercialTimberRightsAccepted"
                      formControlName="stateCommercialTimberRightsAccepted">
                      <label for="stateCommercialTimberRightsAccepted">Acknowledged</label>
                      @if (!stateCommercialTimberRightsValid && !form.pristine) {
                        <div class="alert alert-warning mt-4" id="CommercialTimberWarn"
                          >
                          <i class="fa fa-exclamation-triangle"></i> Required
                        </div>
                      }
                    </li>
                  </ul>
                </li>
              </div>
            </div>
          }
          @if (showKoalaHabitatProtection) {
            <div>
              <li>
                <legend>
                  <span class="label" [innerHtml]="koalaHabitatProtectionHtmlMessage"></span>
                  <abbr title="(required)" class="required">*</abbr>
                </legend>
                <ul class="choices">
                  <li class="required">
                    <input type="checkbox" id="koalaHabitatProtectionAccepted"
                      formControlName="koalaHabitatProtectionAccepted">
                      <label for="koalaHabitatProtectionAccepted">Acknowledged</label>
                      @if (!koalaHabitatProtectionValid && (!form.pristine || koalaHabitatProtectionAccepted?.touched)) {
                        <div class="alert alert-warning mt-4" id="koalaHabitatWarn"
                          >
                          <i class="fa fa-exclamation-triangle"></i> Required
                        </div>
                      }
                    </li>
                  </ul>
                </li>
              </div>
            }
          </ol>
        </div>
      }

      @if (containsWetTropicsQldWorldHeritageArea) {
        <div>
          <span class="label"><h3><i class="fa fa-info-circle"></i> This property is located in the Wet Tropics World Heritage Area.</h3><br/>
          Before commencing clearing on the property you should contact the Wet Tropics Management Authority on phone (07) 4241 0500, wettropics&#64;wtma.qld.gov.au or visit <a href='http://www.wettropics.gov.au' target="_blank">www.wettropics.gov.au</a></span>
          <br/>
          <input type="checkbox" id="isWetTropicsQldWorldHeritageAreaAccepted" formControlName="isWetTropicsQldWorldHeritageAreaAccepted">
          <label for="isWetTropicsQldWorldHeritageAreaAccepted">Acknowledged</label>
          @if (!isWetTropicsQldWorldHeritageAreaValid && (!form.pristine || isWetTropicsQldWorldHeritageAreaAccepted?.touched)) {
            <div class="alert alert-warning mt-4">
              <i class="fa fa-exclamation-triangle"></i> Required
            </div>
          }
        </div>
      }

      @if (showsRecordKeepingAcknowledgementQuestions) {
        <div>
          <h2>Record Keeping Acknowledgements</h2>
          <p>I acknowledge that I will keep the following items for record keeping purposes as part of this
          notification:</p>
          <label for="recordKeepingAcknowledgementAccepted">
            <ul>
              @for (q of questionsRefData; track q; let last = $last) {
                <li class="list-default" [value]="q.acknowledgementQuestionId">
                {{stripTrailingPeriod(q.description)}}{{last ? "." : ";"}}</li>
              }
            </ul>
          </label>
          <div>
            <input type="checkbox" id="recordKeepingAcknowledgementAccepted"
              formControlName="recordKeepingAcknowledgementAccepted">
              <label for="recordKeepingAcknowledgementAccepted"><b>Acknowledge all</b></label>
              @if (!recordKeepingAcknowledgementValid && (!form.pristine || recordKeepingAcknowledgementAccepted?.touched)) {
                <div class="alert alert-warning mt-4" id="recordKeepingQuestionsWarn"
                  >
                  <i class="fa fa-exclamation-triangle"></i> Required
                </div>
              }
            </div>
          </div>
        }
      </form>
      @if (!showStateCommercialTimberRights && !showsRecordKeepingAcknowledgementQuestions) {
        <div class="alert alert-info"
          >
          Please continue to the next screen.
        </div>
      }
      <br />
      <ul class="actions">
        <li> <input class="qg-btn btn-global-secondary" type="submit" (click)="previous()" value="Previous" /> </li>
        <li> <em> <input class="qg-btn btn-primary" type="submit" (click)="next()" value="Next" /> </em> </li>
      </ul>
      <ul class="actions">
        <li>
          <a href (click)="cancel()">Cancel</a>
        </li>
      </ul>
